<div
  class="message"
  [class.account-message]="getClassAccount(message.senderId)"
>
  <div class="message-icon">
    <img
      class="message-icon-img"
      [src]="getImage(message)"
      alt=""
    >
  </div>
  <div class="message-content">
    <div class="message-sender">
      <span>
        {{ getName(message.senderId) }}
      </span>
      @if (!recordCalendarId && message.recordCalendarId) {
        <span>
          Id: {{ message.recordCalendarId }}
        </span>
      }
    </div>

    @if (message.content) {
      <div class="message-text">
        @switch (message.content.type) {
          @case ('TEXT') {
            <span class="message-text-content">
              {{ message.content.text.text }}
            </span>
          }
          @case ('IMAGE') {
            <app-telegram-message-image
              [message]="message"
            />
          }
          @case ('VIDEO') {
            <app-telegram-message-video
              [message]="message"
            />
          }
          @case ('DOCUMENT') {
            <app-telegram-message-document
              [message]="message"
            />
          }
        }
      </div>
      <span class="message-bottom">
        @if (message.content.type !== 'TEXT') {
          <app-telegram-button-save-file
            [messageId]="message.id"
          />
        }
        @if (!message.editDate) {
          <span class="message-time">
            {{ message.date * 1000 | date: 'HH:mm' }}
          </span>
        } @else {
          <span class="message-time">
            edited
            {{ message.editDate * 1000 | date: 'HH:mm' }}
          </span>
        }
        @if(getClassAccount(message.senderId)) {
          <span [class]="getReadClass(message.isRead)"></span>
        }
      </span>
    }
  </div>
</div>
